import { angelopolisApi } from "../../api/angelopolisAPi";
import { isDevice } from "../../utils/isDevice";
import { ModalControler } from "../../components/modals/ModalControler";
export class ModalLotes {
  constructor(scene) {
    if (ModalLotes.instance) {
      return ModalLotes.instance;
    }
    ModalLotes.instance = this;
    this.scene = scene;
    this.modalControler = new ModalControler();
    this.angelopolisApi = new angelopolisApi();
    this.lotesinThisClouster = [];
    this.containerModalLotes = document.getElementById("containerModalLotes");
    this.contentModalLotes = document.getElementById("contentModalLotes");
    this.buttonToShowModal = document.getElementById("buttonToShowModal");
    this.imgArrowModalLote = document.getElementById("imgArrowModalLote");
    this.contentTable = document.getElementById("contentTable");
    this.tableModalLotes = document.getElementById("tableModalLotes");
    this.orderByMeters = document.getElementById("orderByMeters");
    this.orderByPrice = document.getElementById("orderByPrice");
    this.checkLandScapeAndMovile();
    this.eventsListeners();
    this.removeAllChildrens();
  }
  checkLandScapeAndMovile() {
    if (isDevice()) {
      this.containerModalLotes.classList.add("landscape:items-start");
      this.buttonToShowModal.classList.add("landscape:mt-36");
      this.contentModalLotes.classList.add("landscape:h-[328px]");
      this.contentTable.classList.add("landscape:h-262");
      this.tableModalLotes.classList.add("landscape:h-197");
    }
  }

  eventsListeners() {
    this.buttonToShowModal.addEventListener("click", () => {
      if (this.contentModalLotes.classList.contains("hidden")) {
        this.showModal();
      } else {
        this.closeModal();
      }
    });

    this.orderByMeters.addEventListener("click", () => {
      this.onOrderByMeters();
    });
    this.orderByPrice.addEventListener("click", () => {
      this.onOrderByPrice();
    });
  }

  onOrderByMeters() {
    this.lotesinThisClouster.sort(
      (a, b) => b.Disponibilidad - a.Disponibilidad
    );
    this.orderByMeters.classList.replace("bg-white", "bg-004858");
    this.orderByMeters.classList.replace("text-004858", "text-white");
    this.orderByPrice.classList.replace("bg-004858", "bg-white");
    this.orderByPrice.classList.replace("text-white", "text-004858");
    this.drawRows(this.lotesinThisClouster);
  }
  onOrderByPrice() {
    this.lotesinThisClouster.sort((a, b) => b.Precio - a.Precio);
    this.orderByPrice.classList.replace("bg-white", "bg-004858");
    this.orderByPrice.classList.replace("text-004858", "text-white");
    this.orderByMeters.classList.replace("bg-004858", "bg-white");
    this.orderByMeters.classList.replace("text-white", "text-004858");
    this.drawRows(this.lotesinThisClouster);
  }

  removeAllChildrens() {
    this.tableModalLotes.innerHTML = "";
  }

  hiddenCompleteModal() {
    this.containerModalLotes.classList.replace("flex", "hidden");
  }

  roundedDecimals(number) {
    return Math.round(number * 100) / 100;
  }
  round5(x) {
    // return x
    return Math.ceil(x / 5) * 5;
  }
  convertToFormat(number) {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  showCompleteModal(nameClouster = "") {
    const normalizeString = (str) =>
      str
        .normalize("NFD") // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, ""); // Elimina marcas diacríticas
  
    this.lotesinThisClouster = this.angelopolisApi
      .getApiData()
      .filter((lote) => {
        const name = normalizeString(lote.CodigoProducto.split(/[.\s]+/)[0]);
        const normalizedClouster = normalizeString(nameClouster);
        if (
          name.toUpperCase() === normalizedClouster.toUpperCase() &&
          lote.Precio > 0 &&
          lote.Disponibilidad > 0 &&
          lote.Detalle.length >= 1
        ) {
          return lote;
        }
      });
    this.onOrderByMeters();
  }
  

  drawRows(lotesinThisClouster) {
    this.removeAllChildrens();
    lotesinThisClouster.forEach((element) => {
      const priceFMC = parseFloat(element.Precio);
      const comercialPrice = this.roundedDecimals(priceFMC * 1);
      const priceFinale = this.round5(
        Math.round(parseFloat(comercialPrice + comercialPrice * 0))
      );
      const priceFinal = Math.round(priceFinale * 1.06);

      let hexColor = "";
      switch (element.color) {
        case "MORADO":
          hexColor = "4b237b";
          break;

        case "MARINO":
          hexColor = "013e50";
          break;

        case "NARANJA":
          hexColor = "ee623f";
          break;

        case "AZUL":
          hexColor = "1dade1";
          break;

        case "ROJO":
          hexColor = "f72f14";
          break;

        default:
          hexColor = "30b951";
          break;
      }

      const nuevoElemento = document.createElement("div");
      nuevoElemento.setAttribute("id", element._id);
      nuevoElemento.className =
        "w-full h-8 flex items-center justify-evenly cursor-pointer text-black hover:bg-[#d7d7d7]";
      nuevoElemento.innerHTML = `
  <div class="w-3 h-3 mr-2" style="background-color:#${hexColor};" ></div>
  <div class="w-[170px] flex">
    <p class="text-xs circular-spo-bold"></p>
    <p class="text-xs circular-spo-bold font-semibold">${
      " " + element.street.split(".").join(" ")
    }</p>
  </div>
  <div class="w-[80px] text-center">
    <p class="text-xs circular-spo-bold">${element.Disponibilidad} m2</p>
  </div>
  <div class="w-[80px] text-center">
    <p class="text-xs circular-spo-bold">${this.convertToFormat(priceFinal)}</p>
  </div>
`;
      this.tableModalLotes.appendChild(nuevoElemento);
      nuevoElemento.addEventListener("click", () => {
        const title = element.NombreBusqueda.split(/[ .]/).join("_");
        this.modalControler.showModal(title, title);
      });
      nuevoElemento.addEventListener("mouseover", () => {
        // console.log(
        //    this.scene.getObjectByName("Outline_cascatta_MT_ambientacion_0", true)
        // );
      });
    });
    this.containerModalLotes.classList.replace("hidden", "flex");
  }

  closeModal() {
    this.contentModalLotes.classList.add("hidden");
    this.imgArrowModalLote.classList.replace("rotate-0", "rotate-180");
  }
  showModal() {
    this.contentModalLotes.classList.remove("hidden");
    this.imgArrowModalLote.classList.replace("rotate-180", "rotate-0");
  }
}
